/**
 * @deprecated This enum is a legacy artifact and should NOT be used for implementing
 * product-related functionality. All product behaviors should be data-driven and
 * facilitated via the ProductAPI.
 *
 * **Valid use-case:**
 * The only acceptable use of this enum is for mapping recipe identifiers to static
 * client-side assets (e.g., product images, bowl/pack illustrations) that are bundled
 * with the application.
 *
 * **If you need to use this enum for a new feature:**
 * Please reach out to the Product Launch team (\@product-launch or #pod-product-launch) before proceeding.
 * There may be a data-driven solution available, or the team can help evaluate whether
 * your use-case requires adding assets to the client bundle.
 *
 * @see getFreshProductAsset - Example of valid asset mapping usage
 */
export enum RecipeNames {
  BEEF = 'BEEF',
  BEEF_GRAIN = 'BEEF_GRAIN',
  BEEF_MLENTILS = 'BEEF_MLENTILS',
  CHICKENL = 'CHICKENL',
  CHICKEN_AND_GREENS = 'CHICKEN_AND_GREENS',
  CHICKEN_CHIA = 'CHICKEN_CHIA',
  CHICKEN_OATS = 'CHICKEN_OATS',
  CHICKEN_OATS_COLLARDS = 'CHICKEN_OATS_COLLARDS',
  LOW_FAT_CHICKEN = 'LOW_FAT_CHICKEN',
  PORK = 'PORK',
  PORK_GRAIN = 'PORK_GRAIN',
  TURKEY = 'TURKEY',
  TURKEYK = 'TURKEYK',
  TURKEYLL = 'TURKEYLL',
  NO_RECIPE = 'NO_RECIPE',
}

/**
 * @deprecated This constant uses the deprecated RecipeNames enum. Product eligibility
 * and categorization should be determined via the ProductAPI, not hardcoded lists.
 * Contact the Product Launch team (\@product-launch or #pod-product-launch) for data-driven alternatives.
 */
export const LPF_RECIPES = [
  RecipeNames.CHICKEN_OATS,
  RecipeNames.CHICKEN_OATS_COLLARDS,
  RecipeNames.PORK_GRAIN,
  RecipeNames.BEEF_GRAIN,
] as const;
/**
 * @deprecated This type is derived from the deprecated LPF_RECIPES constant.
 * Contact the Product Launch team (\@product-launch or #pod-product-launch) for data-driven alternatives.
 */
export type LpfRecipes = (typeof LPF_RECIPES)[number];
